import PropTypes from 'prop-types';
import { Container, Stack } from '@mui/material';
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';

export default function AdminScreenLayout({ title, breadcrumbs, action, children }) {
  return (
    <Page title={title}>
      <Container maxWidth={false}>
        <HeaderBreadcrumbs heading={title} links={breadcrumbs} action={action} />
        <Stack spacing={3}>{children}</Stack>
      </Container>
    </Page>
  );
}

AdminScreenLayout.propTypes = {
  action: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

AdminScreenLayout.defaultProps = {
  action: null,
};
